import { useEffect, useState } from "react";
import {
  Card,
  Divider,
  Typography,
  Spin,
  Button,
  message,
  Progress,
} from "antd";
import { Image } from "antd";

import Dragger from "antd/es/upload/Dragger";
import {
  DeleteOutlined,
  InboxOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import axiosInstance from "../../../../api/Axios";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  capitalizeWords,
  formatDateWithSuffix,
} from "../../../../components/icons/ApplicationColor";
import {
  modifyFileName,
  uploadFileCourse,
} from "../../CAAdminCoursePages/courseUtils";
const { Title, Text } = Typography;

const CustomerRightEdit = ({ data1, loading, LoadUser, ImpersonateAccess, canEdit }) => {
  const { id } = useParams();

  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [originalImage, setOriginalImage] = useState(null);
  const [imageDeleted, setImageDeleted] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(50);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const CreateSuccessfull = () => {
    LoadUser();
    messageApi.open({
      type: "success",
      content: "New course image uploaded successfully",
      duration: 5,
    });
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Image upload failed",
      duration: 5,
    });
  };
  const handleUpload = async (file) => {
    setUploading(true);
    setUploadPercent(20); // Start at 20%
    let file_name = "";
    try {
      // Simulate progress increments
      setTimeout(() => setUploadPercent(25), 300);
      setTimeout(() => setUploadPercent(40), 450);
      setTimeout(() => setUploadPercent(65), 600);
      setTimeout(() => setUploadPercent(90), 900);
      // Actual upload
      file_name = await uploadFileCourse(file, "course", csrfToken);
      setUploadPercent(100);
    } catch (err) {
      console.log(err);
      setUploadPercent(0);
    } finally {
      setUploading(false);
    }

    if (!file_name) return; // Prevent API call if upload failed

    const finalValues = {
      name: data1?.name,
      organization: userInfo?.data?.organization?.id,
      image_url: file_name,
    };
    try {
      await axiosInstance.put(`/courseedit/?id=${id}`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      CreateSuccessfull();
    } catch (err) {
      CreateFailed();
    }
  };
  const handleClear = () => {
    setPreviewUrl(null);
    setImageDeleted(true);
    setFileList([]);
  };
  const handleChange = async (info) => {
    const file = info.file.originFileObj || info.file;
    const imageUrl = URL.createObjectURL(file);

    setPreviewUrl(imageUrl);
    setFileList([
      {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: imageUrl,
        originFileObj: file,
      },
    ]);

    await handleUpload(file); // Upload after setting preview
  };
  useEffect(() => {
    if (data1?.image_url) {
      const imgUrl = data1.image_url;
      setPreviewUrl(imgUrl);
      setOriginalImage(imgUrl);
      setFileList([
        {
          uid: "-1",
          name: imgUrl.split("/").pop(),
          status: "done",
          url: imgUrl,
        },
      ]);

      setImageDeleted(false); // hide Reset button on load
    } else {
      setOriginalImage(null);
      setImageDeleted(false);
    }
  }, [data1.image_url]);

  const resetToOriginalImage = () => {
    if (originalImage) {
      setPreviewUrl(originalImage);
      setFileList([
        {
          uid: "-1",
          name: originalImage.split("/").pop(),
          status: "done",
          url: originalImage,
        },
      ]);

      setImageDeleted(false); // hide the Reset button again
    }
  };

  const brokerName = useSelector((state) => state.orgdeatil.brokerName);
  const relationship = data1?.account_relationships?.[0];
  const brokerLabel = brokerName || "Insurer";

  return (
    <Card
      bordered
      hoverable
      style={{
        width: "100%",
        padding: "12.5px",
        paddingTop: "5px",
        height: "100%",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        background: "#F9FBFC",
      }}
    >
      {contextHolder}
      <Spin spinning={loading}>
        <Title
          // level={}
          style={{
            fontSize: "15.5px",
            textAlign: "center",
            width: "100%",
            // display: "block",
            fontWeight: "600",
            letterSpacing: 0.5,
            color: "#333333",

            marginBottom: 16,
          }}
        >
          {classification
            ? `${capitalizeWords(classification)} Details`
            : "Customer Details"}
        </Title>
        <Divider />
        <div style={{ width: "100%", textAlign: "center", marginTop: "30px" }}>
          <Dragger
            name="file"
            multiple={false}
            customRequest={({ file }) => {}}
            maxCount={1}
            disabled={!ImpersonateAccess || canEdit === false}
            beforeUpload={() => false}
            showUploadList={false}
            accept="image/*"
            onChange={handleChange}
            fileList={fileList}
            className="custom-dragger"
            openFileDialogOnClick={!previewUrl && canEdit !== false}
            style={{
              minHeight: 180, // Increase height
              minWidth: 180, // Optional: Increase width
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              marginTop: "60px",
              opacity: canEdit === false ? 0.5 : 1,
              cursor: canEdit === false ? "not-allowed" : "pointer",
              // paddinfInline: "0px",
            }}
          >
            {previewUrl ? (
              <div style={{ textAlign: "center" }}>
                <Image
                  src={previewUrl}
                  alt="Uploaded"
                  preview={true}
                  style={{
                    maxHeight: "100px",
                    maxWidth: "100%",
                    objectFit: "contain",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
                <div
                  style={{
                    fontSize: "13px",
                    color: "#595959",
                    marginTop: "7.5px",
                  }}
                >
                  {(() => {
                    const name = fileList[0]?.name;
                    if (!name) return "";

                    const modifiedName = modifyFileName(name); // remove timestamp
                    const dotIndex = modifiedName.lastIndexOf(".");
                    const ext = modifiedName.substring(dotIndex);
                    const base = modifiedName.substring(0, dotIndex);

                    return base.length > 15
                      ? base.substring(0, 15) + "..." + ext
                      : modifiedName;
                  })()}
                  {ImpersonateAccess && canEdit !== false && (
                    <DeleteOutlined
                      onClick={handleClear}
                      style={{ marginLeft: "5px" }}
                    />
                  )}
                </div>
                {uploading && (
                  <Progress
                    percent={uploadPercent}
                    size="small"
                    status={uploadPercent === 100 ? "success" : "active"}
                    style={{ marginTop: 10 }}
                  />
                )}
              </div>
            ) : (
              <>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ fontSize: "25px" }} />
                </p>
                <p
                  style={{ fontSize: "13px", color: "gray", padding: "0 10px" }}
                >
                  Click or drag image to upload
                </p>
              </>
            )}
          </Dragger>
        </div>

        <div
          style={{
            width: "100%",
            textAlign: "left",
            gap: "12.5px",
            display: "flex",
            flexDirection: "column",
            marginInlineStart: "5px",
            marginTop: "90px",
          }}
        >
          {imageDeleted && canEdit !== false && (
            <Button onClick={resetToOriginalImage}>
              <RetweetOutlined style={{ marginLeft: "5px" }} />
              Restore Image
            </Button>
          )}

          <div>
            <Text style={{ color: "gray" }}>Name : </Text>
            <Text>{data1?.name}</Text>
          </div>
          <div>
            <span style={{ color: "gray" }}>
              {classification ? capitalizeWords(classification) : "Customer"} ID
              :{" "}
            </span>
            <Text>{data1?.client_id}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Type : </Text>
            <Text>{data1?.org_type}</Text>
          </div>
          <div>
            <Text style={{ color: "gray" }}>Created At : </Text>
            <Text>{formatDateWithSuffix(data1?.created_at)}</Text>
          </div>
          {relationship && (
            <>
              <div>
                <Text style={{ color: "gray" }}>{brokerLabel} ID : </Text>
                <Text>
                  {relationship?.insurer_id || relationship?.account_id}
                </Text>
              </div>
              <div>
                <Text style={{ color: "gray" }}>{brokerLabel} Name : </Text>
                <Text>
                  {relationship?.insurer_name || relationship?.account_name}
                </Text>
              </div>
            </>
          )}
        </div>

        <Divider />

      </Spin>
    </Card>
  );
};

export default CustomerRightEdit;
